<template lang="pug">
#tabela-patrimonio-pj
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    el-collapse(v-model='activeCollapseItem')
        div(v-for='(item, index) in tiposPatrimonio')
            el-collapse-item(:title='item.titulo', :name='index.toString()')
                template(slot='title')
                    | {{ item.titulo }}
                    i.mdi.mdi-minus-circle.ml-2(v-if='!item.temResultados')(
                        style='font-size: 20px; color: #686868'
                    )
                el-table.table-patrimonio.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesOperador") && dados.aeronavesOperadores',
                    :data='dados.aeronavesOperadores.aeronaves',
                    height='100%',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "fabricante", order: "ascending" }',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.proprietario")',
                        prop='proprietario',
                        :formatter='isEmpty',
                        align='left',
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.fabricante")',
                        prop='fabricante',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.modelo")',
                        prop='modelo',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.matricula")',
                        prop='matricula',
                        :formatter='isEmpty',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoDeFabricacao")',
                        prop='anoFabricacao',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacaoDaAeronavegabilidade")',
                        prop='situacaoAeronavegabilidade',
                        align='left',
                        min-width='230px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesOperador") && !dados.aeronavesOperadores',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesOperador") && dados.aeronavesOperadores'
                )
                    p {{ dados.aeronavesOperadores.aeronaves.length }} {{ dados.aeronavesOperadores.aeronaves.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.aeronave') : $t('mensagens.preAnaliseCredito.patrimonio.aeronaves') }}

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario") && dados.aeronavesProprietarios',
                    :data='dados.aeronavesProprietarios.aeronaves',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "fabricante", order: "ascending" }',
                    stripe
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.operador")',
                        prop='operador',
                        :formatter='isEmpty',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.fabricante")',
                        prop='fabricante',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.modelo")',
                        prop='modelo',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.matricula")',
                        prop='matricula',
                        :formatter='isEmpty',
                        align='left',
                        min-width='160px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoDeFabricacao")',
                        prop='anoFabricacao',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='170px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacaoDaAeronavegabilidade")',
                        prop='situacaoAeronavegabilidade',
                        align='left',
                        min-width='230px'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario") && !dados.aeronavesProprietarios',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
                .tabela-rodape-somatorio(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.aeronavesProprietario") && dados.aeronavesProprietarios'
                )
                    p {{ dados.aeronavesProprietarios.aeronaves.length }} {{ dados.aeronavesProprietarios.aeronaves.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.aeronave') : $t('mensagens.preAnaliseCredito.patrimonio.aeronaves') }}

                BaseInfoBlock(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir',
                    :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.areaTotalDosImoveisComoTitular")]',
                    :valores-info-block='[dados.cafir.areaTotal]',
                    unidade-medida='ha'
                )
                el-divider(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir'
                )
                BaseInfoBlock(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir',
                    :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.quantidadeImoveisClassificadosComoTitular")]',
                    :valores-info-block='[dados.cafir.numeroImoveisTitular]'
                )
                el-divider(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir'
                )
                BaseInfoBlock(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir',
                    :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.quantidadeImoveisClassificadosComoCondominio")]',
                    :valores-info-block='[dados.cafir.numeroImoveisCondomino]'
                )
                el-divider(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir'
                )
                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && itemsImoveisRurais.length > 0',
                    :data='paginatedItemsImoveisRurais',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "nome", order: "ascending" }',
                    stripe,
                    v-loading='isLoadingImoveisRurais',
                    header-fixed
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.nomeDoImovel")',
                        prop='nome',
                        align='left',
                        sortable,
                        min-width='150px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.nirf")',
                        prop='nirf',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.territorio.labels.areaHa")',
                        prop='area',
                        align='left',
                        sortable,
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.municipio")',
                        prop='municipio',
                        align='left',
                        min-width='70px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.uf")',
                        prop='uf',
                        align='left',
                        min-width='30px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.imovelRuralEmCondominio")',
                        prop='condominioInfo',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.vinculoDoImovel")',
                        prop='tipo',
                        align='left',
                        min-width='100px'
                    )
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && dados.cafir'
                    )
                        p {{ dados.cafir.imoveis.length }} {{ dados.cafir.imoveis.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.imovelMinusculo') : $t('mensagens.preAnaliseCredito.patrimonio.imoveisMinusculo') }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && itemsImoveisRurais.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.cafir.imoveis.length',
                        @prev-click='avancarPaginaImoveisRurais',
                        @next-click='voltarPaginaImoveisRurais',
                        @current-change='atualizarPaginaImoveisRurais'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveisRurais") && !dados.cafir',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && itemsImoveis.length > 0',
                    :data='paginatedItemsImoveis',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe,
                    v-loading='isLoadingImoveis'
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.numeroDeMatriculaDoImovel")',
                        prop='imovelId',
                        :formatter='isEmpty',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.municipio")',
                        prop='municipio',
                        :formatter='isEmpty',
                        align='left',
                        min-width='120px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.uf")',
                        prop='uf',
                        :formatter='isEmpty',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.ufDeRegistro")',
                        prop='ufRegistro',
                        :formatter='isEmpty',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.areaDoTerrenoHa")',
                        prop='areaTerreno',
                        :formatter='isEmpty',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.areaConstruidaHa")',
                        prop='areaConstruida',
                        :formatter='isEmpty',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoDeConstrucao")',
                        prop='anoConstrucao',
                        :formatter='isEmpty',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.comuns.acoes")',
                        align='center',
                        min-width='90'
                    )
                        .template.d-flex.justify-content-center(
                            slot-scope='scope'
                        )
                            el-dropdown.action-button(trigger='click')
                                span.el-dropdown-link
                                    i.mdi.mdi-dots-vertical
                                el-dropdown-menu(slot='dropdown')
                                    el-dropdown-item(
                                        icon='el-icon-view',
                                        @click.native='abrirModalDetalhesImoveis(scope.row)'
                                    ) {{ $t('mensagens.preAnaliseCredito.verInformacoesDetalhadas') }}
                BaseModalVisualizarInfos.imovel-modal(
                    v-if='modalDetalhesImoveis',
                    :show='modalDetalhesImoveis',
                    width='500px',
                    @closeDialog='modalDetalhesImoveis = false; dadosModalDetalhesImoveis = ""'
                )
                    slot
                        div
                            p.imovel-modal-title {{ $t('mensagens.preAnaliseCredito.patrimonio.endereco') }}
                            <strong>{{ $t('mensagens.preAnaliseCredito.patrimonio.cep') }}:</strong> {{ formatarCep(dadosModalDetalhesImoveis.cep) || '- -' }}
                            br
                            <strong>{{ $t('mensagens.preAnaliseCredito.patrimonio.bairro') }}:</strong> {{ dadosModalDetalhesImoveis.bairro || '- -' }}
                            br
                            <strong>{{ $t('mensagens.preAnaliseCredito.patrimonio.logradouro') }}:</strong> {{ dadosModalDetalhesImoveis.municipio || '- -' }}
                            br
                            <strong>{{ $t('mensagens.preAnaliseCredito.patrimonio.numero') }}:</strong> {{ dadosModalDetalhesImoveis.numeroLogradouro || '- -' }}
                            br
                            <strong>{{ $t('mensagens.preAnaliseCredito.patrimonio.complemento') }}:</strong> {{ dadosModalDetalhesImoveis.complemento || '- -' }}
                            el-divider
                            p.imovel-modal-title {{ $t('mensagens.preAnaliseCredito.patrimonio.valorDaAvaliacao') }}
                            <strong>{{ $t('mensagens.preAnaliseCredito.patrimonio.valorAvaliacaoImovel') }}:</strong> {{ formatValorBRL(dadosModalDetalhesImoveis.valorAvaliacao) || '- -' }}
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && dados.imoveis'
                    )
                        p {{ dados.imoveis.length }} {{ dados.imoveis.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.imovelMinusculo') : $t('mensagens.preAnaliseCredito.patrimonio.imoveisMinusculo') }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && itemsImoveis.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.imoveis.length',
                        @prev-click='avancarPaginaImoveis',
                        @next-click='voltarPaginaImoveis',
                        @current-change='atualizarPaginaImoveis'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.imoveis") && !dados.imoveis',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.dominios") && itemsDominios.length > 0',
                    :data='paginatedItemsDominios',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "dominio", order: "ascending" }',
                    stripe,
                    v-loading='isLoadingDominios'
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.nome")',
                        prop='dominio',
                        align='left',
                        sortable,
                        min-width='80px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.responsavel")',
                        prop='responsavel',
                        :formatter='isEmpty',
                        align='left',
                        min-width='80px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataCriacao")',
                        prop='criado',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='40px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataAlteracao")',
                        prop='alterado',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='40px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataExpiracao")',
                        prop='expiracao',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='40px'
                    )
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.dominios") && dados.empresaRegistroBr'
                    )
                        p {{ dados.empresaRegistroBr.dominios.length }} {{ dados.empresaRegistroBr.dominios.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.dominioMinusculo') : $t('mensagens.preAnaliseCredito.patrimonio.dominiosMinusculo') }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.dominios") && itemsDominios.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.empresaRegistroBr.dominios.length',
                        @prev-click='avancarPaginaDominios',
                        @next-click='voltarPaginaDominios',
                        @current-change='atualizarPaginaDominios'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.dominios") && !dados.empresaRegistroBr',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.dominiosAssociadosAoCnpj") && dados.empresaDominio'
                )
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.quantidadeDominiosAssociadosCnpj")]',
                        :valores-info-block='[dados.empresaDominio.dominios.length]'
                    )
                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.dominiosAssociadosAoCnpj") && (!dados.empresaDominio || !dados.empresaDominio.dominios.dominio)',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiPatente") && itemsPatentes.length > 0',
                    :data='paginatedItemsPatentes',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "titulo", order: "ascending" }',
                    stripe,
                    v-loading='isLoadingPatentes'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-descriptions.descricao-item-tabela(
                                :size='"mini"',
                                :column='3',
                                direction='vertical'
                            )
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.depositante")'
                                ) {{ props.row.depositante || '- -' }}
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.procurador")'
                                ) {{ props.row.procurador || '- -' }}
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.investidores")'
                                ) {{ formatarTexto(props.row.invetores) }}
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.tituloDaPatente")',
                        prop='titulo',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.numeroDoProcesso")',
                        prop='numeroPedido',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataDeDeposito")',
                        prop='dataDeposito',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataDeConcessao")',
                        prop='dataConcessao',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataDaPublicacao")',
                        prop='dataPublicacao',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='50px'
                    )

                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiPatente") && dados.empresaInpiPatentes'
                    )
                        p {{ dados.empresaInpiPatentes.pedidos.length }} {{ dados.empresaInpiPatentes.pedidos.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.patenteRegistrada') : $t('mensagens.preAnaliseCredito.patrimonio.patentesRegistradas') }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiPatente") && itemsPatentes.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.empresaInpiPatentes.pedidos.length',
                        @prev-click='avancarPaginaPatentes',
                        @next-click='voltarPaginaPatentes',
                        @current-change='atualizarPaginaPatentes'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiPatente") && itemsPatentes.length === 0',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiProgramasDeComputador") && itemsProgramas.length > 0',
                    :data='paginatedItemsProgramas',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "titulo", order: "ascending" }',
                    stripe,
                    v-loading='isLoadingProgramas'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-descriptions.descricao-item-tabela(
                                :size='"mini"',
                                :column='3',
                                direction='vertical'
                            )
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.autores")'
                                ) {{ formatarTexto(props.row.autores) || '- -' }}
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.tituloDoSoftware")',
                        prop='titulo',
                        align='left',
                        sortable,
                        min-width='180px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.numeroDoProcesso")',
                        prop='numeroProcesso',
                        align='left',
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataDoDeposito")',
                        prop='dataDeposito',
                        :formatter='formatarDataTableColumn',
                        align='left',
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.procurador")',
                        prop='procurador',
                        :formatter='isEmpty',
                        align='left',
                        min-width='80px'
                    )

                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiProgramasDeComputador") && dados.empresaInpiProgramas'
                    )
                        p {{ dados.empresaInpiProgramas.processos.length }} {{ dados.empresaInpiProgramas.processos.length === 1 ? 'registro' : 'registros' }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiProgramasDeComputador") && itemsProgramas.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.empresaInpiProgramas.processos.length',
                        @prev-click='avancarPaginaProgramas',
                        @next-click='voltarPaginaProgramas',
                        @current-change='atualizarPaginaProgramas'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiProgramasDeComputador") && itemsProgramas.length === 0',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiMarcas") && itemsMarcas.length > 0',
                    :data='paginatedItemsMarcas',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    :default-sort='{ prop: "marca", order: "ascending" }',
                    stripe,
                    v-loading='isLoadingMarcas'
                )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.tituloDaMarca")',
                        prop='marca',
                        :formatter='isEmpty',
                        align='left',
                        sortable,
                        min-width='120px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.numeroProcesso")',
                        prop='numeroProcesso',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.dataDoDeposito")',
                        :formatter='formatarDataTableColumn',
                        prop='dataDeposito',
                        align='left',
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.situacao")',
                        prop='situacao',
                        :formatter='isEmpty',
                        align='left',
                        min-width='70px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.classe")',
                        prop='classe',
                        align='left',
                        min-width='60px'
                    )
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiMarcas") && dados.inpiMarcas'
                    )
                        p {{ dados.inpiMarcas.length }} {{ dados.inpiMarcas.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.registroMinusculo') : $t('mensagens.preAnaliseCredito.patrimonio.registrosMinusculo') }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiMarcas") && itemsMarcas.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.inpiMarcas.length',
                        @prev-click='avancarPaginaMarcas',
                        @next-click='voltarPaginaMarcas',
                        @current-change='atualizarPaginaMarcas'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.inpiMarcas") && itemsMarcas.length === 0',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesadosPorIdadeDaFrota") && dados.totalizadorEmpresasVeiculosPesados'
                )
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.veiculosPesadosAcimaDeDezAnos")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.acimaDezAnos]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.veiculosPesadosEntreCincoEDezAnos")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.entreCincoDezAnos]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.veiculosPesadosEntreDoisECincoAnos")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.entreDoisCincoAnos]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.veiculosPesadosAteUmAno")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.ateUmAno]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.grupoVeiculosPesadosAcimaDeDezAnos")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.grupoAcimaDezAnos]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.grupoVeiculosPesadosEntreCincoEDezAnos")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.grupoEntreCincoDezAnos]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.grupoVeiculosPesadosEntreDoisECincoAnos")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.grupoEntreDoisCincoAnos]'
                    )
                    el-divider
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.grupoVeiculosPesadosAteUmAno")]',
                        :valores-info-block='[dados.totalizadorEmpresasVeiculosPesados.grupoAteUmAno]'
                    )

                el-alert(
                    v-else-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesadosPorIdadeDaFrota") && !dados.totalizadorEmpresasVeiculosPesados',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )

                div(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesados") && dados.veiculosPesados'
                )
                    BaseInfoBlock(
                        :titulos-info-block='[$t("mensagens.preAnaliseCredito.patrimonio.quantidadeVeiculosPesadosPorGrupo")]',
                        :valores-info-block='[dados.veiculosPesados.length]'
                    )
                el-table.fixed-header-table(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesados") && itemsVeiculosPesados.length > 0',
                    :data='paginatedItemsVeiculosPesados',
                    style='width: 100%; max-height: 300px; overflow: auto',
                    stripe,
                    v-loading='isLoadingVeiculosPesados'
                )
                    el-table-column(type='expand')
                        template(slot-scope='props')
                            el-descriptions.descricao-item-tabela(
                                :size='"mini"',
                                :column='3',
                                direction='vertical'
                            )
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.cadastroNaAntt")'
                                ) {{ props.row.constaAntt === true ? $t('mensagens.comuns.sim') : $t('mensagens.comuns.nao') || '- -' }}
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.chassi")'
                                ) {{ props.row.chassi || '- -' }}
                                el-descriptions-item.has-colon-not(
                                    :label='$t("mensagens.preAnaliseCredito.patrimonio.tipoDeCombustivel")'
                                ) {{ props.row.combustivel || '- -' }}
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.tipo")',
                        prop='tipo',
                        :formatter='isEmpty',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.marca")',
                        prop='marcaModelo',
                        :formatter='isEmpty',
                        align='left',
                        min-width='100px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.modelo")',
                        prop='modelo',
                        :formatter='isEmpty',
                        align='left',
                        min-width='80px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.placa")',
                        prop='placa',
                        :formatter='isEmpty',
                        align='left',
                        min-width='80px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.anoDeFabricacao")',
                        prop='anoFabricacao',
                        :formatter='isEmpty',
                        align='left',
                        min-width='60px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.renavam")',
                        prop='renavam',
                        :formatter='isEmpty',
                        align='left',
                        min-width='50px'
                    )
                    el-table-column(
                        :label='$t("mensagens.preAnaliseCredito.patrimonio.uf")',
                        prop='uf',
                        :formatter='isEmpty',
                        align='left',
                        min-width='30px'
                    )
                .d-flex.flex-row.justify-content-between.align-items-center.border-bottom
                    .tabela-rodape-somatorio(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesados") && dados.veiculosPesados'
                    )
                        p {{ dados.veiculosPesados.length }} {{ dados.veiculosPesados.length === 1 ? $t('mensagens.preAnaliseCredito.patrimonio.veiculoMinusculo') : $t('mensagens.preAnaliseCredito.patrimonio.veiculosMinusculo') }}
                    el-pagination(
                        v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesados") && itemsVeiculosPesados.length > 0',
                        :page-size='6',
                        :pager-count='5',
                        layout='prev, pager, next',
                        :total='dados.veiculosPesados.length',
                        @prev-click='avancarPaginaVeiculosPesados',
                        @next-click='voltarPaginaVeiculosPesados',
                        @current-change='atualizarPaginaVeiculosPesados'
                    )
                el-alert(
                    v-if='item.titulo === $t("mensagens.preAnaliseCredito.patrimonio.veiculosPesados") && !dados.veiculosPesados',
                    :title='`${$t("mensagens.preAnaliseCredito.naoHaRegistroPara")} ${item.titulo}`',
                    type='warning',
                    :closable='false'
                )
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';
import BaseInfoBlock from '@/modules/pre-analise-credito/components/BaseInfoBlock';
import BaseModalVisualizarInfos from '@/modules/pre-analise-credito/components/BaseModalVisualizarInfos';

export default {
    name: 'TabelaPatrimonioPj',

    components: {
        BaseTableHeader,
        BaseInfoBlock,
        BaseModalVisualizarInfos
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            modalDetalhesImoveis: false,
            dadosModalDetalhesImoveis: '',
            activeCollapseItem: ['0'],
            itemsMarcas: [],
            paginaAtualMarcas: 1,
            itemsPorPaginaMarcas: 6,
            isLoadingMarcas: false,
            itemsPatentes: [],
            paginaAtualPatentes: 1,
            itemsPorPaginaPatentes: 6,
            isLoadingPatentes: false,
            itemsProgramas: [],
            paginaAtualProgramas: 1,
            itemsPorPaginaProgramas: 6,
            isLoadingProgramas: false,
            itemsImoveisRurais: [],
            paginaAtualImoveisRurais: 1,
            itemsPorPaginaImoveisRurais: 6,
            isLoadingImoveisRurais: false,
            itemsImoveis: [],
            paginaAtualImoveis: 1,
            itemsPorPaginaImoveis: 6,
            isLoadingImoveis: false,
            itemsDominios: [],
            paginaAtualDominios: 1,
            itemsPorPaginaDominios: 6,
            isLoadingDominios: false,
            itemsVeiculosPesados: [],
            paginaAtualVeiculosPesados: 1,
            itemsPorPaginaVeiculosPesados: 6,
            isLoadingVeiculosPesados: false
        };
    },

    created() {
        this.itemsPatentes = this.dados.empresaInpiPatentes
            ? this.dados.empresaInpiPatentes.pedidos
            : [];
        this.itemsProgramas = this.dados.empresaInpiProgramas
            ? this.dados.empresaInpiProgramas.processos
            : [];
        this.itemsMarcas = this.dados.inpiMarcas ? this.dados.inpiMarcas : [];

        if (this.dados.cafir) {
            this.itemsImoveisRurais = this.dados.cafir.imoveis
                ? this.dados.cafir.imoveis
                : [];
        }

        this.itemsImoveis = this.dados.imoveis ? this.dados.imoveis : [];

        if (this.dados.empresaRegistroBr) {
            this.itemsDominios = this.dados.empresaRegistroBr.dominios
                ? this.dados.empresaRegistroBr.dominios
                : [];
        }

        this.itemsVeiculosPesados = this.dados.veiculosPesados
            ? this.dados.veiculosPesados
            : [];
    },

    computed: {
        tiposPatrimonio() {
            return this.mxCheckTiposPatrimonioPJResults(this.dados) || [];
        },
        totalPagesPatentes() {
            return Math.ceil(
                this.itemsPatentes.length / this.itemsPorPaginaPatentes
            );
        },
        paginatedItemsPatentes() {
            const startIndex =
                (this.paginaAtualPatentes - 1) * this.itemsPorPaginaPatentes;
            const endIndex = startIndex + this.itemsPorPaginaPatentes;
            return this.itemsPatentes.slice(startIndex, endIndex);
        },
        totalPagesProgramas() {
            return Math.ceil(
                this.itemsProgramas.length / this.itemsPorPaginaProgramas
            );
        },
        paginatedItemsProgramas() {
            const startIndex =
                (this.paginaAtualProgramas - 1) * this.itemsPorPaginaProgramas;
            const endIndex = startIndex + this.itemsPorPaginaProgramas;
            return this.itemsProgramas.slice(startIndex, endIndex);
        },
        totalPagesMarcas() {
            return Math.ceil(
                this.itemsMarcas.length / this.itemsPorPaginaMarcas
            );
        },
        paginatedItemsMarcas() {
            const startIndex =
                (this.paginaAtualMarcas - 1) * this.itemsPorPaginaMarcas;
            const endIndex = startIndex + this.itemsPorPaginaMarcas;
            return this.itemsMarcas.slice(startIndex, endIndex);
        },
        totalPagesImoveisRurais() {
            return Math.ceil(
                this.itemsImoveisRurais.length /
                    this.itemsPorPaginaImoveisRurais
            );
        },
        paginatedItemsImoveisRurais() {
            const startIndex =
                (this.paginaAtualImoveisRurais - 1) *
                this.itemsPorPaginaImoveisRurais;
            const endIndex = startIndex + this.itemsPorPaginaImoveisRurais;
            return this.itemsImoveisRurais.slice(startIndex, endIndex);
        },
        totalPagesImoveis() {
            return Math.ceil(
                this.itemsImoveis.length / this.itemsPorPaginaImoveis
            );
        },
        paginatedItemsImoveis() {
            const startIndex =
                (this.paginaAtualImoveis - 1) * this.itemsPorPaginaImoveis;
            const endIndex = startIndex + this.itemsPorPaginaImoveis;
            return this.itemsImoveis.slice(startIndex, endIndex);
        },
        totalPagesDominios() {
            return Math.ceil(
                this.itemsDominios.length / this.itemsPorPaginaDominios
            );
        },
        paginatedItemsDominios() {
            const startIndex =
                (this.paginaAtualDominios - 1) * this.itemsPorPaginaDominios;
            const endIndex = startIndex + this.itemsPorPaginaDominios;
            return this.itemsDominios.slice(startIndex, endIndex);
        },
        totalPagesVeiculosPesados() {
            return Math.ceil(
                this.itemsVeiculosPesados.length /
                    this.itemsPorPaginaVeiculosPesados
            );
        },
        paginatedItemsVeiculosPesados() {
            const startIndex =
                (this.paginaAtualVeiculosPesados - 1) *
                this.itemsPorPaginaVeiculosPesados;
            const endIndex = startIndex + this.itemsPorPaginaVeiculosPesados;
            return this.itemsVeiculosPesados.slice(startIndex, endIndex);
        }
    },

    methods: {
        formatarCep(cep) {
            const cepFormatado = cep.replace(/\D/g, '');
            return cepFormatado.replace(/(\d{5})(\d{3})/, '$1-$2');
        },
        formatValorAvaliadoTableColumn(row, column, valorAvaliado, index) {
            return 'R$ ' + formatters.maxFormatNumber(valorAvaliado, 2);
        },
        formatarDataTableColumn(row, column, data, index) {
            return this.mxFormatarData(data);
        },
        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },
        formatarTexto(texto) {
            if (!texto) {
                return '- -';
            } else {
                return texto.join(', ');
            }
        },
        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        },
        abrirModalDetalhesImoveis(row) {
            this.modalDetalhesImoveis = true;
            this.dadosModalDetalhesImoveis = row;
        },
        voltarPaginaMarcas() {
            this.handleLoadingTableMarcas();
            setTimeout(() => {
                if (this.paginaAtualMarcas > 1) {
                    this.paginaAtualMarcas--;
                }
            }, 550);
        },
        avancarPaginaMarcas() {
            this.handleLoadingTableMarcas();
            setTimeout(() => {
                if (this.paginaAtualMarcas < this.totalPagesMarcas) {
                    this.paginaAtualMarcas++;
                }
            }, 550);
        },
        atualizarPaginaMarcas(pagina) {
            this.handleLoadingTableMarcas();
            setTimeout(() => {
                this.paginaAtualMarcas = pagina;
            }, 550);
        },
        handleLoadingTableMarcas() {
            this.isLoadingMarcas = true;
            setTimeout(() => {
                this.isLoadingMarcas = false;
            }, 500);
        },
        voltarPaginaPatentes() {
            this.handleLoadingTablePatentes();
            setTimeout(() => {
                if (this.paginaAtualPatentes > 1) {
                    this.paginaAtualPatentes--;
                }
            }, 550);
        },
        avancarPaginaPatentes() {
            this.handleLoadingTablePatentes();
            setTimeout(() => {
                if (this.paginaAtualPatentes < this.totalPagesPatentes) {
                    this.paginaAtualPatentes++;
                }
            }, 550);
        },
        atualizarPaginaPatentes(pagina) {
            this.handleLoadingTablePatentes();
            setTimeout(() => {
                this.paginaAtualPatentes = pagina;
            }, 550);
        },
        handleLoadingTablePatentes() {
            this.isLoadingPatentes = true;
            setTimeout(() => {
                this.isLoadingPatentes = false;
            }, 500);
        },
        voltarPaginaProgramas() {
            this.handleLoadingTableProgramas();
            setTimeout(() => {
                if (this.paginaAtualProgramas > 1) {
                    this.paginaAtualProgramas--;
                }
            }, 550);
        },
        avancarPaginaProgramas() {
            this.handleLoadingTableProgramas();
            setTimeout(() => {
                if (this.paginaAtualProgramas < this.totalPagesProgramas) {
                    this.paginaAtualProgramas++;
                }
            }, 550);
        },
        atualizarPaginaProgramas(pagina) {
            this.handleLoadingTableProgramas();
            setTimeout(() => {
                this.paginaAtualProgramas = pagina;
            }, 550);
        },
        handleLoadingTableProgramas() {
            this.isLoadingProgramas = true;
            setTimeout(() => {
                this.isLoadingProgramas = false;
            }, 500);
        },
        voltarPaginaImoveisRurais() {
            this.handleLoadingTableImoveisRurais();
            setTimeout(() => {
                if (this.paginaAtualImoveisRurais > 1) {
                    this.paginaAtualImoveisRurais--;
                }
            }, 550);
        },
        avancarPaginaImoveisRurais() {
            this.handleLoadingTableImoveisRurais();
            setTimeout(() => {
                if (
                    this.paginaAtualImoveisRurais < this.totalPagesImoveisRurais
                ) {
                    this.paginaAtualImoveisRurais++;
                }
            }, 550);
        },
        atualizarPaginaImoveisRurais(pagina) {
            this.handleLoadingTableImoveisRurais();
            setTimeout(() => {
                this.paginaAtualImoveisRurais = pagina;
            }, 550);
        },
        handleLoadingTableImoveisRurais() {
            this.isLoadingImoveisRurais = true;
            setTimeout(() => {
                this.isLoadingImoveisRurais = false;
            }, 500);
        },
        voltarPaginaImoveis() {
            this.handleLoadingTableImoveis();
            setTimeout(() => {
                if (this.paginaAtualImoveis > 1) {
                    this.paginaAtualImoveis--;
                }
            }, 550);
        },
        avancarPaginaImoveis() {
            this.handleLoadingTableImoveis();
            setTimeout(() => {
                if (this.paginaAtualImoveis < this.totalPagesImoveis) {
                    this.paginaAtualImoveis++;
                }
            }, 550);
        },
        atualizarPaginaImoveis(pagina) {
            this.handleLoadingTableImoveis();
            setTimeout(() => {
                this.paginaAtualImoveis = pagina;
            }, 550);
        },
        handleLoadingTableImoveis() {
            this.isLoadingImoveis = true;
            setTimeout(() => {
                this.isLoadingImoveis = false;
            }, 500);
        },
        voltarPaginaDominios() {
            this.handleLoadingTableDominios();
            setTimeout(() => {
                if (this.paginaAtualDominios > 1) {
                    this.paginaAtualDominios--;
                }
            }, 550);
        },
        avancarPaginaDominios() {
            this.handleLoadingTableDominios();
            setTimeout(() => {
                if (this.paginaAtualDominios < this.totalPagesDominios) {
                    this.paginaAtualDominios++;
                }
            }, 550);
        },
        atualizarPaginaDominios(pagina) {
            this.handleLoadingTableDominios();
            setTimeout(() => {
                this.paginaAtualDominios = pagina;
            }, 550);
        },
        handleLoadingTableDominios() {
            this.isLoadingDominios = true;
            setTimeout(() => {
                this.isLoadingDominios = false;
            }, 500);
        },
        voltarPaginaVeiculosPesados() {
            this.handleLoadingTableVeiculosPesados();
            setTimeout(() => {
                if (this.paginaAtualVeiculosPesados > 1) {
                    this.paginaAtualVeiculosPesados--;
                }
            }, 550);
        },
        avancarPaginaVeiculosPesados() {
            this.handleLoadingTableVeiculosPesados();
            setTimeout(() => {
                if (
                    this.paginaAtualVeiculosPesados <
                    this.totalPagesVeiculosPesados
                ) {
                    this.paginaAtualVeiculosPesados++;
                }
            }, 550);
        },
        atualizarPaginaVeiculosPesados(pagina) {
            this.handleLoadingTableVeiculosPesados();
            setTimeout(() => {
                this.paginaAtualVeiculosPesados = pagina;
            }, 550);
        },
        handleLoadingTableVeiculosPesados() {
            this.isLoadingVeiculosPesados = true;
            setTimeout(() => {
                this.isLoadingVeiculosPesados = false;
            }, 500);
        }
    }
};
</script>

<style lang="scss">
#tabela-patrimonio-pj {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    .fixed-header-table .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-table {
        border-radius: 5px;

        .cell {
            word-break: break-word !important;
        }

        .el-table__body-wrapper {
            overflow-x: auto !important;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 14px;
            font-weight: 500;
            line-height: 16.75px;

            th {
                max-width: 132px;
            }
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .action-button {
            cursor: pointer;
        }
    }

    .table-patrimonio {
        height: 100%;
        width: 100%;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }

    .el-dialog__body {
        padding: 0px 20px !important;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }

    .el-dialog__title {
        line-height: 24px;
        font-size: 18px;
        color: #00413c;
        font-weight: bold;
    }

    p.imovel-modal-title {
        color: #00413c;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px !important;
        margin-top: 0px !important;
    }

    .imovel-modal {
        z-index: 9999 !important;
        position: relative !important;
    }
}
</style>
